export const HOME_PAGE_FLOATING_LOGO_CLICKED = 'Home Page Floating Logo Clicked';

export type HomePageFloatingNavLogoState = 'Opened' | 'Closed';

export function homePageFloatingLogoClickedEventProperties(options: {
  floatingNav: HomePageFloatingNavLogoState;
}): Record<string, string> {
  return {
    'Floating Nav': options.floatingNav,
  };
}
